module.exports = __webpack_public_path__ + "assets/img/picto-filter.06eb0a55.svg";